var exports = {
  "e6": "ChannelItem.module__channelItemCore___U2szYj",
  "$H": "ChannelItem.module__channelItemCoreSelected___U2szYj",
  "_B": "ChannelItem.module__channelItemCoreUnselected___U2szYj",
  "Vp": "ChannelItem.module__channelItemCoreHovered___U2szYj",
  "TV": "ChannelItem.module__typingTooltip___U2szYj",
  "kp": "ChannelItem.module__channelTypingIndicator___U2szYj",
  "IM": "ChannelItem.module__typingIndicatorIcon___U2szYj",
  "U4": "ChannelItem.module__channelItemSelected___U2szYj",
  "OI": "ChannelItem.module__typingAvatars___U2szYj",
  "_N": "ChannelItem.module__channelItemIcon___U2szYj",
  "Jz": "ChannelItem.module__channelItemIconSelected___U2szYj",
  "Wk": "ChannelItem.module__categoryContainer___U2szYj",
  "yb": "ChannelItem.module__categoryName___U2szYj",
  "zc": "ChannelItem.module__iconContainer___U2szYj",
  "HA": "ChannelItem.module__channelName___U2szYj",
  "Hq": "ChannelItem.module__actionsContainer___U2szYj",
  "OO": "ChannelItem.module__channelItemIconUnselected___U2szYj",
  "Cr": "ChannelItem.module__channelItemIconHighlight___U2szYj",
  "rC": "ChannelItem.module__channelItemLabel___U2szYj",
  "gw": "ChannelItem.module__channelItemActions___U2szYj",
  "kL": "ChannelItem.module__container___U2szYj",
  "YI": "ChannelItem.module__channelReorderTarget___U2szYj",
  "c2": "ChannelItem.module__channelCategoryReorderTarget___U2szYj",
  "XE": "ChannelItem.module__unreadIndicator___U2szYj",
  "_j": "ChannelItem.module__unreadIndicatorMuted___U2szYj",
  "fc": "ChannelItem.module__channelItem___U2szYj",
  "Z$": "ChannelItem.module__channelItemCategory___U2szYj",
  "RQ": "ChannelItem.module__channelItemRegular___U2szYj",
  "zx": "ChannelItem.module__channelItemHighlight___U2szYj",
  "_R": "ChannelItem.module__channelItemMuted___U2szYj",
  "Td": "ChannelItem.module__channelItemSelectedWithUnread___U2szYj",
  "Fb": "ChannelItem.module__channelItemHoverable___U2szYj",
  "FN": "ChannelItem.module__channelItemPressed___U2szYj",
  "Je": "ChannelItem.module__channelItemOver___U2szYj",
  "X9": "ChannelItem.module__channelItemContextMenu___U2szYj",
  "L5": "ChannelItem.module__channelItemCategoryContextMenu___U2szYj",
  "GJ": "ChannelItem.module__channelItemDragging___U2szYj",
  "rO": "ChannelItem.module__channelItemDimmed___U2szYj",
  "x1": "ChannelItem.module__channelItemMutedState___U2szYj",
  "Ef": "ChannelItem.module__hoverAffordance___U2szYj",
  "Mn": "ChannelItem.module__keyboardFocus___U2szYj",
  "BE": "ChannelItem.module__channelItemAutocompleteHighlight___U2szYj",
  "Yq": "ChannelItem.module__categoryContent___U2szYj",
  "Yl": "ChannelItem.module__categoryIcon___U2szYj",
  "Sk": "ChannelItem.module__createChannelButton___U2szYj",
  "$Z": "ChannelItem.module__createChannelIcon___U2szYj",
  "Ne": "ChannelItem.module__voiceUserCount___U2szYj",
  "lj": "ChannelItem.module__voiceOccupancyTimer___U2szYj",
  "nO": "ChannelItem.module__channelItemVoiceOccupied___U2szYj",
  "cw": "ChannelItem.module__channelItemVoiceConnected___U2szYj",
  "p9": "ChannelItem.module__channelItemVoice___U2szYj",
  "pL": "ChannelItem.module__contextMenuOpen___U2szYj",
  "jL": "ChannelItem.module__channelItemHoverAffordancesActive___U2szYj",
  "I6": "ChannelItem.module__channelGlyph___U2szYj",
};

module.exports = exports;
